import { Stack, Box } from '@chakra-ui/react'
import { SectionTitle } from '@!/Store/Common/components'
import { ScrollableContent } from '@!/Store/Home/components'
import { Content } from './Content'

/* 横スクロール型のコンテンツリスト */
export const ScrollableContents = ({ contents, sectionTitle, url, gtmClick }) => {
  return (
    <Stack gap={0} mx={4}>
      <SectionTitle title={sectionTitle} url={url} gtmClick={gtmClick} />
      <ScrollableContent>
        <Stack direction="row" gap={0}>
          {contents.map((content) => (
            <Box key={`${sectionTitle}-${content.content_id}`} mr={3}>
              <Content contentId={content.content_id} contentName={content.content_name} imageUrl={content.image_url} gtmClick={gtmClick} />
            </Box>
          ))}
        </Stack>
      </ScrollableContent>
    </Stack>
  )
}
